<template>
  <div>
    <Head title="Le Mie Prenotazioni" />
    <h1 class="mb-8 text-3xl font-bold">Le Mie Prenotazioni</h1>

    <!-- Stats Cards -->
    <div class="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
      <div class="bg-white rounded-lg shadow p-6">
        <div class="text-sm text-gray-600 mb-2">Totale Prenotazioni</div>
        <div class="text-3xl font-bold text-indigo-600">{{ stats.total_bookings }}</div>
      </div>
      <div class="bg-white rounded-lg shadow p-6">
        <div class="text-sm text-gray-600 mb-2">Prenotazioni Future</div>
        <div class="text-3xl font-bold text-green-600">{{ stats.upcoming_bookings }}</div>
      </div>
      <div class="bg-white rounded-lg shadow p-6">
        <div class="text-sm text-gray-600 mb-2">Totale Speso</div>
        <div class="text-3xl font-bold text-blue-600">€{{ stats.total_spent }}</div>
      </div>
    </div>

    <!-- Bookings List -->
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="text-left font-bold">
            <th class="px-6 pt-6 pb-4">ID</th>
            <th class="px-6 pt-6 pb-4">Data Visita</th>
            <th class="px-6 pt-6 pb-4">Nome</th>
            <th class="px-6 pt-6 pb-4">Adulti</th>
            <th class="px-6 pt-6 pb-4">Bambini</th>
            <th class="px-6 pt-6 pb-4">Totale</th>
            <th class="px-6 pt-6 pb-4">Stato</th>
            <th class="px-6 pt-6 pb-4">Validato</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="booking in bookings"
            :key="booking.id"
            class="hover:bg-gray-100 focus-within:bg-gray-100 cursor-pointer"
            @click="viewBooking(booking.id)"
          >
            <td class="border-t px-6 py-4">
              <div class="flex items-center">{{ booking.id }}</div>
            </td>
            <td class="border-t px-6 py-4">
              <div class="flex items-center">{{ formatDate(booking.pass_date) }}</div>
            </td>
            <td class="border-t px-6 py-4">
              <div class="flex items-center">{{ booking.first_name }} {{ booking.last_name }}</div>
            </td>
            <td class="border-t px-6 py-4">
              <div class="flex items-center">{{ booking.qty_adults }}</div>
            </td>
            <td class="border-t px-6 py-4">
              <div class="flex items-center">{{ booking.qty_kids }}</div>
            </td>
            <td class="border-t px-6 py-4">
              <div class="flex items-center">€{{ booking.paid_amount }}</div>
            </td>
            <td class="border-t px-6 py-4">
              <span class="px-2 py-1 text-xs rounded" :class="getStatusClass(booking.payment_status)">
                {{ booking.payment_status_label }}
              </span>
            </td>
            <td class="border-t px-6 py-4">
              <span v-if="booking.validated" class="text-green-600">✓</span>
              <span v-else class="text-gray-400">-</span>
            </td>
          </tr>
          <tr v-if="bookings.length === 0">
            <td class="border-t px-6 py-4 text-center" colspan="8">
              Nessuna prenotazione trovata.
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- New Booking Button -->
    <div class="mt-8 flex justify-center">
      <Link href="/checkout?returnUrl=/account" class="btn-blue">
        Nuova Prenotazione
      </Link>
    </div>
  </div>
</template>

<script>
import AccountLayout from "@/Pages/Account/Shared/AccountLayout.vue";
import { Head, Link } from "@inertiajs/inertia-vue3";
import moment from "moment";
import "moment/locale/it"; // Import Italian locale for moment.js

export default {
  components: {
    Head,
    Link,
  },
  layout: AccountLayout,
  props: {
    bookings: Array,
    stats: Object,
  },
  methods: {
    formatDate(date) {
      return moment(date).locale("it").format("DD MMMM YYYY");
    },
    getStatusClass(status) {
      if (status === 1) {
        return "bg-green-100 text-green-800";
      }
      return "bg-gray-100 text-gray-800";
    },
    viewBooking(id) {
      this.$inertia.visit(`/account/bookings/${id}`);
    },
  },
};
</script>

<style scoped>
.btn-blue {
  @apply px-6 py-3 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500;
}
</style>
